import {Component, computed, inject, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {SidenavService} from '../../../pages/dashboard/utils/sidenav.service';
import {LocationStateService} from '../../services/location-state.service';
import { Router, RouterLink, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  imports: [CommonModule, MatIcon, MatIconButton, MatMenuModule, RouterLink, MatButton],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  private locationStateService = inject(LocationStateService);
  private sideNavService = inject(SidenavService);
  private router = inject(Router);

  locations = computed(() => this.locationStateService.locations());
  currentLocation = this.locationStateService.currentLocation;

  isDropdownOpen = false;
  showLocationMenu = true;

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.showLocationMenu = !this.router.url.includes('devices');
      });
  }

  selectLocation(location: any) {
    this.locationStateService.setLocation(location);
  }

  toggleSidenav() {
    this.sideNavService.toggle();
  }
}
